import {NEEDS_ATTENTION, SEE_ALL, SUBTITLE1, TEXT} from '@/utils/constants';
import {Box, Typography} from '@mui/material';
import {ReactComponent as ArrowLineRightIcon} from '@/assets/icons/arrow-line-right.svg';
import {attentionListStyle} from './AttentionListStyle.styles';
import Button from '@/shared/components/Button';
import AttentionItem from './AttentionItem';
import {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getDashboardAttentionList, getDashboardAttentionListSelector} from '@/store/organization-dashboard';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {useGetOrganizationId} from '@/utils/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';

export enum NotificationType {
	DUPLICATES = 'Possible Duplicates',
	NO_SEATING = 'No Seating Assignment',
	NO_MIN_BID = 'Auction Item Without Minimum Bid',
}

export interface INotificationItem {
	id: string;
	type: NotificationType;
	description: string;
	createdAt: string;
}

const AttentionList = () => {
	const dispatch = useAppDispatch();

	const organizationId = useGetOrganizationId();
	const currentEvent = useAppSelector(getCurrentEventSelector);
	const attentionList = useAppSelector(getDashboardAttentionListSelector);

	const getAttentionListData = () => {
		if (!organizationId || !currentEvent) return;

		try {
			dispatch(getDashboardAttentionList({organizationId, eventId: currentEvent.id})).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		getAttentionListData();
	}, []);

	return (
		<Box sx={attentionListStyle.wrapper}>
			<Box sx={attentionListStyle.header}>
				<Typography variant={SUBTITLE1}>{NEEDS_ATTENTION}</Typography>

				{/* {attentionList.length > 0 && (
					<Button onClick={() => {}} variant={TEXT} title={SEE_ALL} endIcon={<ArrowLineRightIcon />} />
				)} */}
			</Box>

			<Box sx={attentionListStyle.list}>
				{attentionList.length > 0 ? (
					attentionList.map((item) => <AttentionItem item={item} key={item.id} />)
				) : (
					<Typography sx={{textAlign: 'center', color: 'var(--neutral-400)'}}>
						No items require your attention.
					</Typography>
				)}
			</Box>
		</Box>
	);
};

export default AttentionList;
